import { useRef, useState } from "react";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import CustomSnackbar from "../Common/snackBar";
import EmailTemplateEditModal from "./EmailTemplateEditModal";
import EmailTemplatesListing from "./EmailTemplatesListing";
import EmailTemplateView from "./EmailTemplateView";

const Templates = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const emailTemplateRef = useRef(null);
  const [selectedEmailTemplateId, setSelectedEmailTemplateId] = useState(null);
  const [selectedEmailTemplateView, setSelectedEmailTemplateView] = useState(null);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const refetchEmailTemplateList = () => {
    emailTemplateRef.current?.refetchEmailTemplateListing();
  };

  const handleEdit = (id) => {
    setSelectedEmailTemplateId(id);
  };

  const handleView = (body) => {
    setSelectedEmailTemplateView(body);
  };

  return (
    <div id="kt_content_container">
      <BreadcrumbsComponent />

      <EmailTemplatesListing
        ref={emailTemplateRef}
        handleEdit={handleEdit}
        handleView={handleView}
      />

      {selectedEmailTemplateId && (
        <EmailTemplateEditModal
          emailTemplateId={selectedEmailTemplateId}
          open={!!selectedEmailTemplateId}
          onOpenChange={(open) => !open && setSelectedEmailTemplateId(null)}
          fetchEmailTemplatesList={refetchEmailTemplateList}
        />
      )}

      {selectedEmailTemplateView && (
        <EmailTemplateView
          templateBody={selectedEmailTemplateView}
          open={!!selectedEmailTemplateView}
          onOpenChange={(open) => !open && setSelectedEmailTemplateView(null)}
        />
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default Templates;
